import {observer} from "mobx-react";
import Accordion from "../../../models/Accordion";
import {
    Box,
    Divider,ListItemIcon,
    ListItemText,
    MenuItem,
    MenuList,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useStore} from "../../../stores/Store";
import {BassType} from "../../../models/BassType";
import pianoIcon from '../../../assets/img/icons/accordionNavigationPianoIcon.png'
import buttonIcon from '../../../assets/img/icons/accordionNavigationButtonIcon.png'
import {Brand} from "../../../models/Brand";
import BrandIcon from "../../Misc/BrandIcon/BrandIcon";

interface AccordionDetailedNavigationProps {
    accordion: Accordion,
}

export default observer(function AccordionDetailedNavigation({accordion}: AccordionDetailedNavigationProps){
    const location = useLocation();
    const navigate = useNavigate();
    const {AccordionStore, LanguageStore} = useStore();
    const {accordions} = AccordionStore;
    const {currentLanguageMessages} = LanguageStore;
    const [filteredAccordions, setFilteredAccordions] = useState<Accordion[]>([]);

    useEffect(() => {
        setFilteredAccordions(accordions.filter(a => a.keysOrBut === accordion.keysOrBut && a.bassType === accordion.bassType))
    }, []);

    const handleNavigation = (id: number) => {
        navigate(`/Accordions/${id}`)
    }

    return (
        <Box sx={{height: '100%', borderRadius: '20px', backgroundColor: 'rgba(20,20,20,0.2)', p:3}}>
            <Box sx={{width: '100%', justifyContent: 'center', display: 'flex', mb: 2}}>
                <img style={{height: '200px', borderRadius: '20px'}} src={(accordion.keysOrBut === 'piano') ? pianoIcon : buttonIcon} alt={'navigation-icon'} />
            </Box>
            <Typography textAlign={'center'} variant={'h6'}>
                {(accordion.bassType === BassType.Convertor) ? currentLanguageMessages.AccordionsPage.Filter.BassType.convertor : currentLanguageMessages.AccordionsPage.Filter.BassType.standard}
                {'  |  '}
                {(accordion.keysOrBut === 'piano') ? currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys : currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.buttons}
            </Typography>
            <Divider sx={{mb: 2, mt: 2}} />
            <MenuList>
                {
                    filteredAccordions.map(a =>
                        <MenuItem key={a.id} onClick={() => handleNavigation(a.id)}>
                            <ListItemIcon>
                                <BrandIcon
                                    brand={a.brand}
                                    style={{width: '30px', height: '30px',  borderRadius: (a.brand === Brand.Pigini) ? '5px' : '50%'}}
                                />
                            </ListItemIcon>
                            <ListItemText sx={{whiteSpace: 'normal', overflowWrap: 'break-word'}}><Typography>{a.name}</Typography></ListItemText>
                        </MenuItem>
                    )
                }
            </MenuList>
        </Box>
    )
})